export default __webpack_public_path__ + "static/media/tile_cruise.0d409cb4.jpg";